import { isCesium } from "../../../MapStore2/web/client/selectors/maptype";

import { workspaceModeSelector } from "../../common/selector/configurationSelector";
import { contextSelector, viewSelector } from "./workspaceChangesSelector";
import { BASELINE_VIEW, CONTEXT_BASELINE } from "../changesConstants";
import { RootState } from "../../rootState";

export const selectedChangeTypesSelector = (state: RootState) =>
    workspaceModeSelector(state) ? [] : state.changes.changeType && state.changes.changeType.changeType;
export const workspaceChangeTypesSelector = (state: RootState) =>
    isCesium(state)
        ? []
        : selectedChangeTypesSelector(state) &&
          selectedChangeTypesSelector(state).filter((changeType) => ["I", "U", "N"].includes(changeType));
export const baselineChangeTypesSelector = (state: RootState) =>
    isCesium(state)
        ? []
        : contextSelector(state) === CONTEXT_BASELINE || viewSelector(state) === BASELINE_VIEW
        ? ["O", "W"]
        : selectedChangeTypesSelector(state) &&
          selectedChangeTypesSelector(state).filter((changeType) => ["O", "W"].includes(changeType));
